export const STORE_ADMIN_PLANNED_HOTELS = 'adminPlannedHotels';
export const ADMIN_PH_SET_OPTIONS = 'setOptions';
export const ADMIN_PH_IMPORT = 'actionImport';

export const PLANNED_HOTELS_URL = '/api/frontend/admin/planned_hotels';
